import React from 'react'
import { Navigate } from 'react-router-dom'

import useInvoiceUiVersion, { UI_VERSIONS } from './useInvoiceUiVersion'

/**
 * Which of the two sales order screens /sales/order/create shows.
 *
 * The alternative was editing the sidebar, the dashboard shortcut and every
 * other link every time the default changed — two rounds of edits across the
 * app to change one preference, and a salesperson's bookmark broken with it.
 *
 * Instead the existing URL keeps working and decides for itself, from the
 * per-person preference in useInvoiceUiVersion. Nobody has to be re-pointed
 * when that default changes again.
 *
 * `replace`, not a push: a redirected route in the history means Back sends you
 * to the URL you just came from, which redirects you forward again, and Back
 * stops working.
 */
export default function CounterRoute({ children }) {
    const [uiVersion] = useInvoiceUiVersion()
    return uiVersion === UI_VERSIONS.LEGACY ? children : <Navigate to="/sales/order/new" replace />
}

/**
 * The mirror image, on /sales/order/new: someone who has opted back to the
 * old screen and then follows an old link, or a bookmark, should land on the
 * screen they chose rather than the one they turned off.
 */
export function CounterOnlyRoute({ children }) {
    const [uiVersion] = useInvoiceUiVersion()
    return uiVersion === UI_VERSIONS.LEGACY ? <Navigate to="/sales/order/create" replace /> : children
}
